var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-title"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.subtitle)?_c('h6',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"header-right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }